// Enums do Domínio Organização

export enum CategoriaUnidade {
  QODE_MACRO = 'QODE_MACRO',
  ESTRUTURA_INTERNA = 'ESTRUTURA_INTERNA',
}

export const CategoriaUnidadeLabel: Record<CategoriaUnidade, string> = {
  [CategoriaUnidade.QODE_MACRO]: 'Unidade Macro (QODE)',
  [CategoriaUnidade.ESTRUTURA_INTERNA]: 'Estrutura Interna',
};

export enum TipoUnidade {
  COMANDO_GERAL = 'COMANDO_GERAL',
  DEPARTAMENTO = 'DEPARTAMENTO',
  DIRETORIA = 'DIRETORIA',
  CENTRO = 'CENTRO',
  COMANDO_POLICIAMENTO = 'COMANDO_POLICIAMENTO',
  BATALHAO = 'BATALHAO',
  REGIMENTO = 'REGIMENTO',
  COMPANHIA = 'COMPANHIA',
  ESQUADRAO = 'ESQUADRAO',
  DIVISAO = 'DIVISAO',
  SECAO = 'SECAO',
  SUBSECAO = 'SUBSECAO',
  GABINETE = 'GABINETE',
  ASSESSORIA = 'ASSESSORIA',
  CHEFIA_INTERNA = 'CHEFIA_INTERNA',
  OUTRO = 'OUTRO',
}

export const TipoUnidadeLabel: Record<TipoUnidade, string> = {
  [TipoUnidade.COMANDO_GERAL]: 'Comando-Geral',
  [TipoUnidade.DEPARTAMENTO]: 'Departamento',
  [TipoUnidade.DIRETORIA]: 'Diretoria',
  [TipoUnidade.CENTRO]: 'Centro',
  [TipoUnidade.COMANDO_POLICIAMENTO]: 'Comando de Policiamento',
  [TipoUnidade.BATALHAO]: 'Batalhão',
  [TipoUnidade.REGIMENTO]: 'Regimento',
  [TipoUnidade.COMPANHIA]: 'Companhia',
  [TipoUnidade.ESQUADRAO]: 'Esquadrão',
  [TipoUnidade.DIVISAO]: 'Divisão',
  [TipoUnidade.SECAO]: 'Seção',
  [TipoUnidade.SUBSECAO]: 'Subseção',
  [TipoUnidade.GABINETE]: 'Gabinete',
  [TipoUnidade.ASSESSORIA]: 'Assessoria',
  [TipoUnidade.CHEFIA_INTERNA]: 'Chefia Interna',
  [TipoUnidade.OUTRO]: 'Outro',
};

export enum NaturezaUnidade {
  OPERACIONAL = 'OPERACIONAL',
  APOIO = 'APOIO',
}

export const NaturezaUnidadeLabel: Record<NaturezaUnidade, string> = {
  [NaturezaUnidade.OPERACIONAL]: 'Atividade-Fim (Operacional)',
  [NaturezaUnidade.APOIO]: 'Atividade-Meio (Apoio)',
};

export enum TipoSubordinacao {
  HIERARQUICA = 'HIERARQUICA',
  FUNCIONAL = 'FUNCIONAL',
}

export const TipoSubordinacaoLabel: Record<TipoSubordinacao, string> = {
  [TipoSubordinacao.HIERARQUICA]: 'Subordinação Hierárquica',
  [TipoSubordinacao.FUNCIONAL]: 'Subordinação Funcional',
};

export enum TipoChefia {
  COMANDO_GERAL = 'COMANDO_GERAL',
  COMANDO = 'COMANDO',
  DIRECAO = 'DIRECAO',
  CHEFIA = 'CHEFIA',
}

export const TipoChefiaLabel: Record<TipoChefia, string> = {
  [TipoChefia.COMANDO_GERAL]: 'Comandante-Geral (CMTG)',
  [TipoChefia.COMANDO]: 'Comandante (CMT)',
  [TipoChefia.DIRECAO]: 'Diretor (DIR)',
  [TipoChefia.CHEFIA]: 'Chefe (CHF)',
};

export enum TipoPessoa {
  PM = 'PM',
  CIVIL = 'CIVIL',
}

export const TipoPessoaLabel: Record<TipoPessoa, string> = {
  [TipoPessoa.PM]: 'Policial Militar',
  [TipoPessoa.CIVIL]: 'Servidor Civil',
};

export enum TipoQuadro {
  OFICIAL = 'OFICIAL',
  PRACA = 'PRACA',
}

export const TipoQuadroLabel: Record<TipoQuadro, string> = {
  [TipoQuadro.OFICIAL]: 'Oficial',
  [TipoQuadro.PRACA]: 'Praça',
};

export enum StatusSimulacao {
  RASCUNHO = 'RASCUNHO',
  EM_ANALISE = 'EM_ANALISE',
  APROVADO = 'APROVADO',
  REJEITADO = 'REJEITADO',
  PUBLICADO = 'PUBLICADO',
  CANCELADO = 'CANCELADO',
}

export const StatusSimulacaoLabel: Record<StatusSimulacao, string> = {
  [StatusSimulacao.RASCUNHO]: 'Rascunho',
  [StatusSimulacao.EM_ANALISE]: 'Em Análise',
  [StatusSimulacao.APROVADO]: 'Aprovado',
  [StatusSimulacao.REJEITADO]: 'Rejeitado',
  [StatusSimulacao.PUBLICADO]: 'Publicado',
  [StatusSimulacao.CANCELADO]: 'Cancelado',
};

export enum Patente {
  CEL = 'CEL',
  TC = 'TC',
  MAJ = 'MAJ',
  CAP = 'CAP',
  '1TEN' = '1TEN',
  '2TEN' = '2TEN',
  ASP = 'ASP',
  ST = 'ST',
  '1SGT' = '1SGT',
  '2SGT' = '2SGT',
  '3SGT' = '3SGT',
  CB = 'CB',
  SD = 'SD',
  SD2CLS = 'SD2CLS',
}

export const PatenteLabel: Record<Patente, string> = {
  [Patente.CEL]: 'Coronel (CEL)',
  [Patente.TC]: 'Tenente-Coronel (TC)',
  [Patente.MAJ]: 'Major (MAJ)',
  [Patente.CAP]: 'Capitão (CAP)',
  [Patente['1TEN']]: '1º Tenente (1º TEN)',
  [Patente['2TEN']]: '2º Tenente (2º TEN)',
  [Patente.ASP]: 'Aspirante (ASP)',
  [Patente.ST]: 'Subtenente (ST)',
  [Patente['1SGT']]: '1º Sargento (1º SGT)',
  [Patente['2SGT']]: '2º Sargento (2º SGT)',
  [Patente['3SGT']]: '3º Sargento (3º SGT)',
  [Patente.CB]: 'Cabo (CB)',
  [Patente.SD]: 'Soldado (SD)',
  [Patente.SD2CLS]: 'Soldado de 2ª Classe (SD 2ª CLS)',
};

export enum CodigoQuadro {
  QOPM = 'QOPM',
  QOPMSM = 'QOPMSM',
  QOPMSD = 'QOPMSD',
  QOPMSV = 'QOPMSV',
  QOPMC = 'QOPMC',
  QOPMA = 'QOPMA',
  QOPMES = 'QOPMES',
  QOPMEM = 'QOPMEM',
  QOPMEA = 'QOPMEA',
  QOPMEC = 'QOPMEC',
  QOPMEV = 'QOPMEV',
  QOPMM = 'QOPMM',
  QPPMC = 'QPPMC',
  QPMP_1 = 'QPMP_1',
  QPMP_3 = 'QPMP_3',
  QPMP_4 = 'QPMP_4',
  QPMP_5 = 'QPMP_5',
  QPMP_6S = 'QPMP_6S',
  QPMP_6V = 'QPMP_6V',
  QPMP_7 = 'QPMP_7',
  QPMP_9 = 'QPMP_9',
  CIVIL = 'CIVIL',
}

export const CodigoQuadroLabel: Record<CodigoQuadro, string> = {
  [CodigoQuadro.QOPM]: 'QOPM - Oficiais Combatentes',
  [CodigoQuadro.QOPMSM]: 'QOPMSM - Oficiais Médicos',
  [CodigoQuadro.QOPMSD]: 'QOPMSD - Oficiais Dentistas',
  [CodigoQuadro.QOPMSV]: 'QOPMSV - Oficiais Veterinários',
  [CodigoQuadro.QOPMC]: 'QOPMC - Oficiais Capelães',
  [CodigoQuadro.QOPMA]: 'QOPMA - Oficiais de Administração',
  [CodigoQuadro.QOPMES]: 'QOPMES - Oficiais Especialistas (Saúde)',
  [CodigoQuadro.QOPMEM]: 'QOPMEM - Oficiais Especialistas (Músicos)',
  [CodigoQuadro.QOPMEA]: 'QOPMEA - Oficiais Especialistas (Armamento)',
  [CodigoQuadro.QOPMEC]: 'QOPMEC - Oficiais Especialistas (Comunicações)',
  [CodigoQuadro.QOPMEV]: 'QOPMEV - Oficiais Especialistas (Veterinária)',
  [CodigoQuadro.QOPMM]: 'QOPMM - Oficiais Músicos',
  [CodigoQuadro.QPPMC]: 'QPPMC - Praças Policiais Militares Combatentes',
  [CodigoQuadro.QPMP_1]: 'QPMP-1 - Praças Auxiliares de Saúde',
  [CodigoQuadro.QPMP_3]: 'QPMP-3 - Praças Auxiliares de Comunicações',
  [CodigoQuadro.QPMP_4]: 'QPMP-4 - Praças Músicos',
  [CodigoQuadro.QPMP_5]: 'QPMP-5 - Praças Auxiliares de Corneta',
  [CodigoQuadro.QPMP_6S]: 'QPMP-6S - Praças Auxiliares Especialistas (Saúde)',
  [CodigoQuadro.QPMP_6V]: 'QPMP-6V - Praças Auxiliares Especialistas (Veterinária)',
  [CodigoQuadro.QPMP_7]: 'QPMP-7 - Praças Auxiliares Especialistas (Músicos)',
  [CodigoQuadro.QPMP_9]: 'QPMP-9 - Praças Artífices (Em Extinção)',
  [CodigoQuadro.CIVIL]: 'Servidores Civis',
};

// Interfaces de Dados

export interface Quadro {
  codigo: CodigoQuadro;
  nome: string;
  tipo: TipoQuadro;
  efetivoFixadoLei?: Record<string, number>;
  emExtincao?: boolean;
}

export interface QuadroCreate {
  codigo: CodigoQuadro;
  nome: string;
  tipo: TipoQuadro;
  efetivoFixadoLei?: Record<string, number>;
  emExtincao?: boolean;
}

export interface QuadroUpdate {
  nome?: string;
  efetivoFixadoLei?: Record<string, number>;
  emExtincao?: boolean;
}

export interface Funcao {
  id: string;
  unidadeId: string;
  descricao: string;
  quadro: CodigoQuadro;
  patente?: Patente;
  quantidadePrevista: number;
  tipoPessoa: TipoPessoa;
  gratificada: boolean;
  simboloCargo?: string | null;
  acumuladaPorFuncaoId?: string | null;
  observacao?: string | null;
  dataInicioVigencia?: string | null;
  dataFimVigencia?: string | null;
}

export interface FuncaoCreate {
  descricao: string;
  quadro: CodigoQuadro;
  patente?: Patente;
  quantidadePrevista: number;
  tipoPessoa: TipoPessoa;
  gratificada: boolean;
  simboloCargo?: string | null;
  acumuladaPorFuncaoId?: string | null;
  observacao?: string | null;
}

export interface FuncaoUpdate extends FuncaoCreate {}

export interface FuncaoGratificadaResumo {
  id: string;
  unidadeId: string;
  nomeUnidade: string;
  descricao: string;
  simboloCargo: string;
  quadro: CodigoQuadro;
  patente?: Patente;
  quantidadePrevista: number;
}

export interface PrevistoItem {
  quadro: CodigoQuadro;
  patente?: Patente;
  tipoPessoa: TipoPessoa;
  quantidadePrevista: number;
}

export interface PrevistoUnidade {
  unidadeId: string;
  nomeUnidade: string;
  totalPrevisto: number;
  itens: PrevistoItem[];
}

export interface UnidadeResumo {
  id: string;
  codigoQo: string;
  sigla: string;
  nome: string;
  tipo: TipoUnidade;
  categoria: CategoriaUnidade;
  natureza?: NaturezaUnidade | null;
  ativo: boolean;
}

export interface Unidade {
  id: string;
  codigoQo: string;
  sigla: string;
  nome: string;
  unidadePaiId?: string | null;
  tipo: TipoUnidade;
  categoria: CategoriaUnidade;
  natureza?: NaturezaUnidade | null;
  tipoSubordinacao?: TipoSubordinacao | null;
  tipoChefia?: TipoChefia | null;
  ativo: boolean;
  dataInicioVigencia?: string | null;
  dataFimVigencia?: string | null;
  normaReferencia?: string | null;
  enderecoLogradouro?: string | null;
  enderecoNumero?: string | null;
  enderecoComplemento?: string | null;
  enderecoBairro?: string | null;
  enderecoCep?: string | null;
  telefones?: string[];
  filhos?: Unidade[];
  totalSubunidades?: number;
  totalSecoes?: number;
}

export interface UnidadeCreate {
  codigoQo: string;
  sigla: string;
  nome: string;
  unidadePaiId?: string | null;
  tipo: TipoUnidade;
  categoria: CategoriaUnidade;
  natureza?: NaturezaUnidade | null;
  tipoSubordinacao?: TipoSubordinacao | null;
  dataInicioVigencia?: string | null;
  normaReferencia?: string | null;
  enderecoLogradouro?: string | null;
  enderecoNumero?: string | null;
  enderecoComplemento?: string | null;
  enderecoBairro?: string | null;
  enderecoCep?: string | null;
  telefones?: string[];
}

export interface UnidadeUpdate {
  nome: string;
  unidadePaiId?: string | null;
  tipo: TipoUnidade;
  natureza?: NaturezaUnidade | null;
  tipoSubordinacao?: TipoSubordinacao | null;
  ativo?: boolean;
  dataInicioVigencia?: string | null;
  dataFimVigencia?: string | null;
  normaReferencia?: string | null;
  enderecoLogradouro?: string | null;
  enderecoNumero?: string | null;
  enderecoComplemento?: string | null;
  enderecoBairro?: string | null;
  enderecoCep?: string | null;
  telefones?: string[];
}

export interface SubordinadasResponse {
  unidadeId: string;
  subordinadas: string[];
}

export interface SecaoInternaCreate {
  codigoQo: string;
  sigla: string;
  nome: string;
  tipo: string; // CHEFIA_INTERNA, SECAO, etc.
  unidadePaiInternaId: string;
}

export interface SecaoInternaUpdate {
  nome?: string;
  tipo?: string;
  unidadePaiInternaId?: string;
}

export interface QodeLancamentoResumo {
  id: string;
  numeroQo: string;
  numeroPortaria: string;
  dataPortaria: string;
  dataVigencia: string;
  dataFimVigencia?: string | null;
  simulacaoId?: string | null;
  publicadoPor: string;
  publicadoEm: string;
}

export interface QodeLancamentoDetalhe extends QodeLancamentoResumo {
  snapshotJson: Record<string, any>;
}

export interface QodePublicacaoRequest {
  numeroQo: string;
  numeroPortaria: string;
  dataPortaria: string;
  dataVigencia: string;
}

export interface QodeSimulacaoResumo {
  id: string;
  nome: string;
  descricao?: string | null;
  status: StatusSimulacao;
  criadoPor: string;
  criadoEm: string;
  baseadoEmQodeId?: string | null;
}

export interface QodeSimulacaoDetalhe extends QodeSimulacaoResumo {
  submetidoPor?: string | null;
  submetidoEm?: string | null;
  analisadoPor?: string | null;
  analisadoEm?: string | null;
  parecerAnalise?: string | null;
  aprovadoPor?: string | null;
  aprovadoEm?: string | null;
  publicadoPor?: string | null;
  publicadoEm?: string | null;
  workspaceJson: Record<string, any>;
}

export interface SimulacaoCreate {
  nome: string;
  descricao?: string | null;
  baseadoEmQodeId?: string | null;
}

export interface SimulacaoWorkspaceUpdate {
  workspaceJson: Record<string, any>;
}

export interface RejeitarSimulacaoRequest {
  parecerAnalise: string;
}

export interface ComparativoSimulacao {
  simulacaoId: string;
  unidadesCriadas: UnidadeResumo[];
  unidadesExtintas: UnidadeResumo[];
  unidadesReorganizadas: Array<{
    unidade: UnidadeResumo;
    alteracoes: Array<{
      campo: string;
      valorAnterior: string;
      valorNovo: string;
    }>;
  }>;
  variacaoPrevisto: Array<{
    quadro: CodigoQuadro;
    patente: Patente;
    previstoAtual: number;
    previstoNovo: number;
    delta: number;
  }>;
}

export interface ImpactoSimulacao {
  simulacaoId: string;
  totalUnidadesAfetadas: number;
  unidadesCriadas: number;
  unidadesExtintas: number;
  unidadesReorganizadas: number;
  variacaoEfetivoPorPatente: Array<{
    quadro: CodigoQuadro;
    patente: Patente;
    delta: number;
  }>;
  funcoesGratificadasImpactadas: number;
  alertaTeto: boolean;
  alertaTetoDetalhe?: string | null;
}

export interface RelatorioAtividadeGroup {
  natureza: NaturezaUnidade;
  totalPrevisto: number;
  percentual: number;
  itensPorQuadroPatente: PrevistoItem[];
  unidades: Array<{
    id: string;
    sigla: string;
    nome: string;
    previsto: number;
  }>;
}

export interface RelatorioAtividadeMeioFim {
  dataReferencia?: string | null;
  totalGeralPrevisto: number;
  grupos: RelatorioAtividadeGroup[];
}

export interface ImportacaoResultado {
  totalProcessadas: number;
  totalSucesso: number;
  totalErro: number;
  erros: Array<{
    linha: number;
    motivo: string;
  }>;
}

export interface Problem {
  type: string;
  title: string;
  status: number;
  detail: string;
  instance?: string;
}
